export default "__VITE_ASSET__BurOjqRA__"